export type AdminNavItem = {
  name: string
  labelKey: string
  icon: string
  children?: AdminNavItem[]
}

export type AdminNavGroup = {
  id: string
  labelKey: string
  items: AdminNavItem[]
}

export const adminNavGroups: AdminNavGroup[] = [
  {
    id: 'overview',
    labelKey: 'admin.nav.groups.overview',
    items: [
      { name: 'admin-dashboard', labelKey: 'admin.nav.dashboard', icon: 'dashboard' },
      { name: 'admin-analytics', labelKey: 'admin.nav.analytics', icon: 'bar_chart' },
    ],
  },
  {
    id: 'directory',
    labelKey: 'admin.nav.groups.directory',
    items: [
      { name: 'admin-users', labelKey: 'admin.nav.users', icon: 'people' },
      { name: 'admin-organizations', labelKey: 'admin.nav.organizations', icon: 'business' },
      { name: 'admin-projects', labelKey: 'admin.nav.projects', icon: 'folder' },
      { name: 'admin-forms', labelKey: 'admin.nav.forms', icon: 'description' },
    ],
  },
  {
    id: 'access',
    labelKey: 'admin.nav.groups.access',
    items: [
      { name: 'admin-roles-and-permissions', labelKey: 'admin.nav.roles', icon: 'security' },
      { name: 'admin-permission-groups', labelKey: 'admin.nav.permissionGroups', icon: 'group' },
    ],
  },
  {
    id: 'integrations',
    labelKey: 'admin.nav.groups.integrations',
    items: [
      {
        name: 'admin-agent',
        labelKey: 'admin.nav.agent',
        icon: 'ai',
        children: [
          { name: 'admin-agent', labelKey: 'admin.nav.agentDashboard', icon: 'dashboard' },
          { name: 'admin-agent-subscriptions', labelKey: 'admin.nav.agentSubscriptions', icon: 'subscriptions' },
          { name: 'admin-agent-usage', labelKey: 'admin.nav.agentUsage', icon: 'analytics' },
          { name: 'admin-agent-audit', labelKey: 'admin.nav.agentAudit', icon: 'history' },
        ],
      },
      { name: 'admin-global-odk-servers', labelKey: 'admin.nav.globalOdk', icon: 'dns' },
    ],
  },
  {
    id: 'platform',
    labelKey: 'admin.nav.groups.platform',
    items: [
      { name: 'admin-system', labelKey: 'admin.nav.system', icon: 'settings_system_daydream' },
      { name: 'admin-audit', labelKey: 'admin.nav.audit', icon: 'history' },
      { name: 'admin-subscriptions', labelKey: 'admin.nav.subscriptions', icon: 'card_membership' },
    ],
  },
]

export function isAdminNavActive(routeName: string | symbol | null | undefined, item: AdminNavItem): boolean {
  if (typeof routeName !== 'string') return false
  if (routeName === item.name) return true
  if (item.children?.some((child) => isAdminNavActive(routeName, child))) return true
  // Parent Agent item stays active on any admin-agent* route even if child list omitted at call site
  if (item.name === 'admin-agent' && routeName.startsWith('admin-agent')) return true
  return false
}
